import { GraphQLInt, GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql';

const AMAudienceZipCodeType = new GraphQLObjectType({
  name: 'AMAudienceZipCode',
  description: 'A Zip Code for an ActiveMatch Subscription Audience',
  fields: () => ({
    zipCode: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'ActiveMatch ZipCode Audience ZipCode',
    },
    radius: {
      type: GraphQLInt,
      description: 'ActiveMatch ZipCode Audience for audience geo-query',
    },
  }),
});

export default AMAudienceZipCodeType;
